import { render, staticRenderFns } from "./TasksNav.vue?vue&type=template&id=16c5468c&"
import script from "./TasksNav.vue?vue&type=script&lang=js&"
export * from "./TasksNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports